import {ValueDefinition} from '@/model/types';

export enum UnitraxPeriodicDepositFrequency {
  Annual = 'DV-99#0',
  Bimonthly = 'DV-99#1',
  Biweekly = 'DV-99#2',
  Monthly = 'DV-99#3',
  Quarterly = 'DV-99#4',
  SemiAnnual = 'DV-99#5',
  Weekly = 'DV-99#6',
}

export const DV_99 = {
  id: 'DV-99',
  description: {
    fr: 'Fréquence dépôts périodiques Unitrax',
    en: 'Unitrax periodic deposits frequency',
  },
  values: [
    {
      id: '0',
      value: {
        fr: 'Annuel',
        en: 'Annual',
      },
    },
    {
      id: '1',
      value: {
        fr: 'Bimestriel',
        en: 'Bimonthly',
      },
    },
    {
      id: '2',
      value: {
        fr: 'Aux 2 semaines',
        en: 'Biweekly',
      },
    },
    {
      id: '3',
      value: {
        fr: 'Mensuel',
        en: 'Monthly',
      },
    },
    {
      id: '4',
      value: {
        fr: 'Trimestriel',
        en: 'Quarterly',
      },
    },
    {
      id: '5',
      value: {
        fr: 'Semestriel',
        en: 'Semi-annual',
      },
    },
    {
      id: '6',
      value: {
        fr: 'Hebdomadaire',
        en: 'Weekly',
      },
    },
  ],
} as const satisfies ValueDefinition;
